import groupBy from "lodash.groupby";
import { Store } from "pullstate";
import { supabase } from "./api";
import { MS_FIVE_MINUTES } from "./helpers/utils";

const today = new Date()
today.setHours(0,0,0,0)

export const ELNStore = new Store({
  allUsers: [],
  currentUser: undefined,
  currentDate: today,
  shopFilter: [],
  products: [],
  categorisedProducts: [],
  suppliers: [],
  categories: [],
  shops: [],
  requests: {
    products: new Date().getTime()-MS_FIVE_MINUTES,
    suppliers: new Date().getTime()-MS_FIVE_MINUTES,
    categories: new Date().getTime()-MS_FIVE_MINUTES,
    shops: new Date().getTime()-MS_FIVE_MINUTES,
  },
  range: [new Date(), new Date('31 dec 2100')]
});

export const updateProducts = async () => {

  const { requests } = ELNStore.getRawState()
  const diff = new Date().getTime() - requests.products

  if (diff < MS_FIVE_MINUTES) return

  console.log('updating products...')
  const { data: products, error: productsErr } = await supabase
    .from('products')
    .select('*, categories (*), suppliers (*), shopProducts (*)')
         
  let categorisedProducts = Object.entries(groupBy(products, p => p.categories?.position))

  // sort - supabase sort not working?
  categorisedProducts = categorisedProducts.sort(function(a, b) { return (parseInt(a[0]) > parseInt(b[0]) ? 1 : -1) })

  categorisedProducts = categorisedProducts.map(cp => [cp[1][0].categories.name,cp[1]])

  ELNStore.update(s => { 
    s.products = products
    s.categorisedProducts = categorisedProducts
    s.requests.products = new Date().getTime()
  })
}

export const addProducts = async (newlyCreatedProducts) => {
  const { products } = ELNStore.getRawState()
  const newProducts = [...products, ...newlyCreatedProducts]
  ELNStore.update(s => { 
    s.products = newProducts
  })
}

export const updateSuppliers = async () => {
  const { requests } = ELNStore.getRawState()
  const diff = new Date().getTime() - requests.suppliers
  if (diff < MS_FIVE_MINUTES) return

  console.log('updating suppliers...')
  const { data } = await supabase
    .from('suppliers')
    .select()
    .order('name')

  ELNStore.update(s => { 
    s.suppliers = data
    s.requests.suppliers = new Date().getTime()
  })
}

export const updateCategories = async () => {
  const { requests } = ELNStore.getRawState()
  const diff = new Date().getTime() - requests.categories
  if (diff < MS_FIVE_MINUTES) return

  console.log('updating categories...')
  const { data } = await supabase
    .from('categories')
    .select()
    .order('name')

  ELNStore.update(s => { 
    s.categories = data
    s.requests.categories = new Date().getTime()
  })
}

export const updateShops = async () => {
  const { requests } = ELNStore.getRawState()
  const diff = new Date().getTime() - requests.shops

  if (diff < MS_FIVE_MINUTES) return

  console.log('updating shops...')
  const { data } = await supabase
    .from('shops')
    .select('*, brands (*)')
    .order('name')

  console.log('shops=',data)
  ELNStore.update(s => { 
    s.shops = data
    s.requests.shops = new Date().getTime()
  })
}

export default ELNStore;
